import axios from 'axios';
import { toast } from 'react-toastify';
import { config } from '../../config/envs';
import { generateTraceId } from '../helpers';

const ADMIN_BASE_URL = config.app.adminBaseUrl;

export const getUsers = async (filters) => {
  try {
    const paramAliases = {
      perPage: 'per_page',
      linkType: 'link_type',
    };

    const params = new URLSearchParams();

    for (const [key, value] of Object.entries(filters)) {
      const hasValue = value !== undefined && value !== null && value !== '';

      if (hasValue) {
        const paramKey = paramAliases[key] || key;
        params.append(paramKey, value);
      }
    }

    const response = await axios.get(
      `${ADMIN_BASE_URL}/v2/users/?${params.toString()}`,
    );
    return response;
  } catch (error) {
    toast.error('Não foi possível carregar os usuários');
    return { data: [], total: 0 };
  }
};

export const getUser = async (id) => {
  try {
    const response = await axios.get(`${ADMIN_BASE_URL}/v2/users/${id}`);
    return response;
  } catch (error) {
    toast.error('Não foi possível carregar o usuário');
    return {};
  }
};

export const inactivateUser = async (id) => {
  try {
    const response = await axios.post(
      `${ADMIN_BASE_URL}/v2/users/${id}/inactivate`,
      {},
      { headers: { 'x-trace-id': generateTraceId() } },
    );
    return response;
  } catch (error) {
    toast.error('Não foi possível inativar o usuário');
    return {};
  }
};

export const logoutAllDevices = async (id) => {
  try {
    const response = await axios.post(
      `${ADMIN_BASE_URL}/v2/users/${id}/logout-all-devices`,
      {},
      { headers: { 'x-trace-id': generateTraceId() } },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const promoteUserToAdmin = async (id) => {
  try {
    const response = await axios.post(
      `${ADMIN_BASE_URL}/v2/users/${id}/promote-admin`,
      {},
      { headers: { 'x-trace-id': generateTraceId() } },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const demoteUserFromAdmin = async (id) => {
  try {
    const response = await axios.post(
      `${ADMIN_BASE_URL}/v2/users/${id}/demote-admin`,
      {},
      { headers: { 'x-trace-id': generateTraceId() } },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const impersonateUser = async ({ userId, clientId }) => {
  const body = userId ? { user_id: userId } : { client_id: clientId };

  return axios.post(`${ADMIN_BASE_URL}/auth/impersonate`, body, {
    headers: { 'x-trace-id': generateTraceId() },
  });
};

export const getClients = async (filters) => {
  try {
    const paramAliases = {
      perPage: 'per_page',
    };

    const params = new URLSearchParams();
    const safeFilters = filters || {};

    for (const [key, value] of Object.entries(safeFilters)) {
      const hasValue = value !== undefined && value !== null && value !== '';

      if (hasValue) {
        const paramKey = paramAliases[key] || key;
        params.append(paramKey, value);
      }
    }

    const response = await axios.get(
      `${ADMIN_BASE_URL}/clients/?${params.toString()}`,
    );
    return response;
  } catch (error) {
    toast.error('Não foi possível carregar os clientes');
    return { data: { data: [], total: 0 } };
  }
};

export const confirmClientRegistration = async (clientId) => {
  return axios.post(
    `${ADMIN_BASE_URL}/auth/confirm-registration/${clientId}`,
    {},
  );
};

export const generatePasswordSetupLink = async (clientId) => {
  return axios.post(
    `${ADMIN_BASE_URL}/auth/password-setup-link/${clientId}`,
    {},
  );
};

export const getClientQueries = async (clientId, filters) => {
  try {
    const response = await axios.get(
      `${ADMIN_BASE_URL}/clients/${clientId}/queries?page=${filters.page}&perPage=${filters.perPage}`,
    );
    return response;
  } catch (error) {
    toast.error('Não foi possível carregar as consultas');
    return { data: [], total: 0 };
  }
};

export const getUserAccessHistory = async (clientId, { limit = 1 } = {}) => {
  try {
    const response = await axios.get(
      `${ADMIN_BASE_URL}/user-access-control/history/${clientId}`,
      { params: { limit } },
    );
    return response;
  } catch (error) {
    toast.error('Não foi possível carregar o histórico de acesso');
    throw error;
  }
};

export const getClientAccessStatus = async (clientId) => {
  try {
    const response = await axios.get(
      `${ADMIN_BASE_URL}/user-access-control/${clientId}`,
    );
    return response;
  } catch (error) {
    toast.error('Não foi possível carregar o status de acesso do cliente');
    throw error;
  }
};

// Funções de cupons v2 / plans v2 / addons v2 migraram para
// api/payments/coupons, api/payments/plans e api/payments/addons.
